import React from 'react'

import { GET_BOX_CLICK } from 'artkive/constants/tracker/mainNavigation'
import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'
import useSale from 'artkive/hooks/useSale'

import { ActionButton, InfoWrap, SubTitle, Title } from './HeroSection.style'

const SaleContent = () => {
  const isMobile = useMobileBreakpoint()
  const { name, priceLabel, boxCheckoutUrl } = useSale()

  return (
    <InfoWrap>
      <SubTitle variant={isMobile ? 'body1' : 'subtitle1'}>{name.toUpperCase()}</SubTitle>
      <Title variant='h1' style={{ maxWidth: '460px' }}>
        {name}: {priceLabel} Artkive Box
      </Title>
      <ActionButton
        color='primary'
        variant='contained'
        style={{ width: '180px' }}
        href={boxCheckoutUrl}
        trackerEvent={GET_BOX_CLICK}
        trackerOptions={{ section: 'home_start_banner' }}
      >
        Get My {priceLabel} Box
      </ActionButton>
    </InfoWrap>
  )
}

export default SaleContent
